module.exports = __webpack_public_path__ + "img/Instagram.ad68e6e9.svg";